import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function PopularComics() {
  const popularComics = comics.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              热门韩漫推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              精选高分韩国漫画，品质阅读之选
            </p>
          </div>
          <Link
            to="/category"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap flex items-center gap-1"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {popularComics.map((comic) => (
            <ComicCard key={comic.id} {...comic} />
          ))}
        </div>
      </div>
    </section>
  );
}